import React from 'react';
import { useParams } from 'react-router-dom';

import { Heading, Stack, Text } from '@eluve/components';

import { AddModelArgsToPromptTemplateDialog } from './AddModelArgsToPromptTemplateDialog';
import { PromptTemplateModelArgsList } from './PromptTemplateModelArgsList';

export const PromptTemplateModelArgsListPage: React.FC = () => {
  const { promptTemplateId } = useParams() as { promptTemplateId: string };

  return (
    <Stack gap={2} align="stretch">
      <Stack direction="horizontal" justify="between" align="stretch">
        <Stack fullWidth={false} gap={1}>
          <Heading size="2xl" weight="semibold">
            Model Prompt Templates
          </Heading>
          <Text weight="regular">
            This prompt template is currently configured to work with the
            following Model Arg configurations
          </Text>
        </Stack>
        <AddModelArgsToPromptTemplateDialog
          promptTemplateId={promptTemplateId}
        />
      </Stack>
      <PromptTemplateModelArgsList
        promptTemplateId={promptTemplateId}
        disableView
      />
    </Stack>
  );
};
